import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Table } from "primeng/table";
import { Observable, Subscription } from 'rxjs';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.scss']
})
export class SearchDialogComponent{
  @Input() isVisible: boolean = true;
  @Input() fieldName: string = "";
  @Input() values: any[] = [];
  @Input() key: string = "";
  @Input() fieldNameByLang: string = "";
  @Input() currentLanguage!: string;
  @Output() onToggleTag: EventEmitter<any> = new EventEmitter<any>();
  selectedItem: any;
  constructor() {}

  checkContains(dt: Table, $event: any) {

    const filterValue = $event.target.value.toLowerCase();

    if (filterValue === '') {
      dt.value = this.values;
      dt.reset();
      return;
    }

    if (Array.isArray(dt.value) && dt.value.length === 0) {
      const langField = this.currentLanguage === 'he' ? 'hebrew' : 'english';

      const filteredValues = this.values.filter(item => {
        const langValue: string = item[this.fieldName][langField];
        return langValue && langValue.toLowerCase().includes(filterValue);
      });

      if (filteredValues.length > 0) {
        dt.value = filteredValues;
        dt.reset();
      }
    }
    else if (Array.isArray(dt.value) && typeof dt.value[0][this.fieldName] === 'object'
      && 'hebrew' in dt.value[0][this.fieldName] && 'english' in dt.value[0][this.fieldName]) {
      const langField = this.currentLanguage === 'he' ? 'hebrew' : 'english';

      const filteredValues = this.values.filter(item => {
        const langValue: string = item[this.fieldName][langField];
        return langValue && langValue.toLowerCase().includes(filterValue);
      });

      dt.value = filteredValues.length > 0 ? filteredValues : [];
      dt.reset();
    } else if (Array.isArray(dt.value) && typeof dt.value[0][this.fieldName] === 'string') {
      dt.filterGlobal($event.target.value, 'contains');
    }
  }


  toggleTag(rowData: any) {    
    this.onToggleTag.emit(rowData);
  }

}
